import moment from 'moment'

import { EetSubmission } from '@invo.space/shared'
import { Receipt, ReceiptLine } from '@invo.space/shared'
import { API_URL } from '@/lib/api'
import { Printer } from '@/lib/printer/printer'

export const receiptPaymentLabel: Record<string, string> = {
  Cash: 'Hotově',
  Card: 'Kartou',
  Qr: 'QR kód',
}

/** Číslo účtenky, jak ho tiskne backend (YYYYMMDDHHmmss z data vystavení). */
export const receiptSymbol = (receipt: Pick<Receipt, 'issuedAt' | 'id'>) =>
  receipt.issuedAt ? moment(receipt.issuedAt).format('YYYYMMDDHHmmss') : receipt.id

export const receiptCurrency = (receipt: Receipt) => receipt.receiptLines[0]?.unitPrice?.currency ?? 'CZK'

/** Celkem v haléřích. unitPrice je už po slevě. */
export const lineTotalMinor = (line: ReceiptLine) => Number(line.unitPrice?.amount ?? 0) * line.amount

export const receiptTotal = (receipt: Receipt) => receipt.receiptLines.reduce((sum, line) => sum + lineTotalMinor(line), 0)

export const receiptTaxFree = (receipt: Receipt) =>
  receipt.receiptLines.reduce((sum, line) => sum + Number(line.unitPriceTaxFree?.amount ?? line.unitPrice?.amount ?? 0) * line.amount, 0)

export const lineLabel = (line: ReceiptLine) => line.label || line.product?.name || line.description || 'Vlastní položka'

export const receiptPermalink = (receipt: Pick<Receipt, 'id'>) => `${API_URL}/api/v2/permalink/receipt/${receipt.id}`

export const invoiceReference = (receipt: Receipt) => receipt.references?.find((r) => r.targetType === 'invoice')

export const eetStatusTone: Record<EetSubmission['status'], string> = {
  confirmed: 'paid',
  pending: 'pending',
  offline: 'unmatched',
  rejected: 'overdue',
}

export const eetStatusLabel: Record<EetSubmission['status'], string> = {
  confirmed: 'Potvrzeno',
  pending: 'Odesílá se',
  offline: 'Offline',
  rejected: 'Zamítnuto',
}

export const formatTime = (value: string) => moment(value).format('H:mm')
export const formatDateTime = (value: string) => moment(value).format('D. M. YYYY, H:mm')

/** Vytiskne textovou verzi účtenky na USB tiskárně (pokud není připojená, nabídne výběr zařízení). */
export const printReceiptOnUsb = async (printer: Printer, receipt: Pick<Receipt, 'id'>) => {
  if (!printer.isReady()) await printer.requestDevice()
  if (!printer.isReady()) throw new Error('Tiskárna není připojená')
  const response = await fetch(receiptPermalink(receipt), { headers: { Accept: 'text/plain' } })
  if (!response.ok) throw new Error('Účtenku se nepodařilo načíst')
  await printer.print(await response.text())
}
